// Libs
import { css } from 'styled-components'

// Comps
import { colors, mobileScreen } from '../../utils'
import { clearButtonStyles, px } from '../../utils/styles'

export const shareEventModalStyles = css`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  min-width: 0px;
  max-width: 448px;
  height: auto;
  min-height: auto;

  padding: 50px;

  ${mobileScreen(css`
    width: calc(100% - 40px);
    max-width: 100%;
    margin-left: 20px;
    margin-right: 20px;
  `)}

  .text-block {
    .header {
      margin-bottom: 15px;
      text-align: left;
    }

    p {
      width: 100%;
      max-width: 305px;
      margin-bottom: 20px;
      font-size: 14px;
      line-height: 20px;
    }
  }

  .calendar-cta {
    margin-bottom: 20px;

    .icon-container {
      /* Center icon with text */
      display: inline-block;
      position: relative;
      height: 1rem;
      width: ${px(19)};
      margin-right: 10px;

      svg {
        position: absolute;
        top: 0px;
        left: 0px;
        margin-left: 50%;
        margin-top: 50%;
        transform: translateY(-50%) translateX(-50%);
        object-fit: cover;
      }
    }
  }

  .share-event-on-header {
    font-size: 14px;
    line-height: 20px;
    color: ${colors.grey};
    margin-bottom: 5px;
  }

  .share-network {
    width: 100%;
    max-width: 242px;

    display: flex;
    flex-wrap: wrap;

    .shareButton {
      margin-right: 15px;
      cursor: pointer;
      flex-shrink: 0;
    }

    .share-button-link {
      ${clearButtonStyles}
      position: relative;
      width: 32px;
      height: 32px;
      display: flex;

      justify-content: center;
      align-items: center;

      border-radius: 16px;
      background: #e5e6eb;

      /* Rebuild the accessability focus border that the others have */
      &:focus {
        &:before {
          content: ' ';
          position: absolute;
          left: 0px;
          right: 0px;
          top: 0px;
          bottom: 0px;
          border: 2px solid;
          border-radius: 4px;
        }
      }
    }
  }
`
